import React from "react";
import { Modal, Button } from "react-bootstrap";

export default function ApproveModel({ show, handleClose, handle,type="record" }) {
  return (
    <Modal
      show={show}
      size="md"
      onHide={handleClose}
      centered
      backdrop="static"
      className="add_subproduct msl_model"
    >
      <Modal.Header closeButton className="border-0 pb-0">
        <Modal.Title className="font_blue_20 font-600 ">Approve</Modal.Title>
      </Modal.Header>
      <Modal.Body className="text-center">
        <p className="font_blue_18">
          {`Are you sure you want to Approve?`}
        </p>
      </Modal.Body>
      <Modal.Footer className="d-flex justify-content-center">
        <Button variant="success" className="success_btn" onClick={handle}>
          Approve
        </Button>
        <Button
          variant="secondary"
          className="cancel_btn"
          onClick={handleClose}
        >
          Cancel
        </Button>
      </Modal.Footer>
    </Modal>
  );
}
